import DocumentTemplates from '../../../../store/documents/templates';

angular
    .module('festzelt-os.contacts')
    .factory('DocumentTemplates', [
        '$injector',
        'DocumentTemplate',
        ($injector, DocumentTemplate) => new DocumentTemplates(DocumentTemplate, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/store/template.js